import { render } from "./HeroCard.vue?vue&type=template&id=f9284152&scoped=true"
import script from "./HeroCard.vue?vue&type=script&lang=js"
export * from "./HeroCard.vue?vue&type=script&lang=js"

import "./HeroCard.vue?vue&type=style&index=0&id=f9284152&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9284152"]])

export default __exports__